module.exports = __webpack_public_path__ + "img/bicycle-none-right.6be3c13a.jpg";